<template>
  <div class="centered-container">
    <v-card>
      <v-card-title>{{ $t('account.personalData.title') }}</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="updatePersonalData">
          <v-text-field
            id="login"
            v-model="email"
            :error-messages="$t(errorMsg)"
            name="email"
            :label="$t('account.personalData.email')"
            type="email"
            :rules="rules.email"
            required
            @focus="resetServerError"
          />
          <v-text-field
            id="firstName"
            v-model="firstName"
            name="firstName"
            :label="$t('account.personalData.firstName')"
            type="text"
            :rules="[rules.name]"
            required
            @focus="resetServerError"
          />
          <v-text-field
            id="lastName"
            v-model="lastName"
            name="lastName"
            :label="$t('account.personalData.lastName')"
            type="text"
            :rules="[rules.name]"
            required
            @focus="resetServerError"
          />
          <div class="text-center">
            <v-btn
              :loading="loading"
              color="primary"
              :disabled="!valid"
              type="submit"
              >{{ $t('account.personalData.updateButton') }}</v-btn
            >
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.centered-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      valid: false,
      email: '',
      firstName: '',
      lastName: '',
      language: '',
      rules: {
        min: (v) =>
          v.length >= 8 ||
          this.$i18n.t('account.personalData.errors.minLength'),
        name: (v) => {
          return !!v || this.$i18n.t('account.personalData.errors.nameRequired')
        },
        email: [
          (v) =>
            !!v || this.$i18n.t('account.personalData.errors.emailRequired'),
          (v) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
            this.$i18n.t('account.personalData.errors.emailInvalid')
        ]
      }
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.auth.loading,
      errorMsg: (state) => state.user.auth.error
    })
  },
  created() {
    // Define app section
    this.$store.dispatch('app/setSection', 'account')

    // Define window title
    this.$store.dispatch(
      'app/setTitle',
      this.$i18n.t('account.personalData.pageTitle')
    )

    // Initialize with cloned store values
    this.firstName = JSON.parse(
      JSON.stringify(this.$store.state.user.firstName)
    )
    this.lastName = JSON.parse(JSON.stringify(this.$store.state.user.lastName))
    this.email = JSON.parse(JSON.stringify(this.$store.state.user.email))
    this.locale = JSON.parse(JSON.stringify(this.$store.state.user.locale))
  },
  methods: {
    resetServerError: function () {
      this.$store.dispatch('user/resetAuthError')
    },
    updatePersonalData: function () {
      const { email, firstName, lastName, locale } = this

      this.$store
        .dispatch('user/updatePersonalData', {
          email,
          firstName,
          lastName,
          locale
        })
        .then(() => {
          this.$store.dispatch(
            'app/setSnackBarSuccess',
            'account.personalData.accountUpdatedSnack',
            {
              root: true
            }
          )
          this.$router.push({ name: 'account' })
        })
        .catch(() => {})
    }
  }
}
</script>
